<template>
  <collapsible-widget
    :collapsed="collapsed"
    :class="is_highlight_selected?'highlight':''"
    :uuid="uuid"
    :title="title_component"
    :badge="badge"
    v-show="id_selected ? id_selected == is_output_selected : true"
    :icon="this.attributes.icon"
    :colorBadge="
      this.attributes.type_collapsible == 'output' ? 'info' : 'primary'
    "
    :message="this.config.attributes.message ? true : false"
    :id="this.attributes.model"
  >
    <div slot="default" :class="clazz">
      <component
        :class="`md-card-content ${title_component} ${type_component}`"
        v-for="element in config.elements"
        :key="element.id"
        :is="getComponentName(element)"
        :config="element"
      ></component>
    </div>
  </collapsible-widget>
</template>

<script>
import componentMixin from "ireal-vue/mixins/component-mixin.js";
import inputComponentMixin from "ireal-vue/mixins/input-component-mixin.js";
import CollapsibleWidget from "ireal-vue/widgets/CollapsibleWidget.vue";
import HelpWidget from "ireal-vue/widgets/HelpWidget.vue";
import Bus from "../services/bus.js";

export default {
  name: "collapsible-component",
  mixins: [componentMixin, inputComponentMixin],
  components: { CollapsibleWidget, HelpWidget },
  data() {
    return {
      is_output_selected: null,
      is_highlight_selected: null,
      visible: true,
      badge: "badge_filter",
    };
  },
  async mounted() {
    this.attributes.type_component
      ? (this.badge = `badge_${this.attributes.type_component}`)
      : "";
    this.color = "info";
    Bus.$on("selected-changed", async (payload) => {
      this.is_output_selected = `${
        this.$store.getters.listSelected[this.model_selected]
      }`;
      if(this.attributes.model){
              this.attributes.model==this.$store.getters.listSelected['highlight'] && this.attributes.model!=''?this.is_highlight_selected=true:this.is_highlight_selected=false
      }

    });
  },
  computed: {
    help() {
      return this.attributes.help ? this.tx(`${this.attributes.help}`) : "";
    },
    help_style() {
      return this.attributes.help;
    },
  },
};
</script>
<style scoped>
.video {
  padding: 0px;
}
.setup {
  padding: 3%;
}
.highlight{
  box-shadow:1px 1px 10px 1px #068bea
}

</style>
